import { CqsDto } from "@/lib/cqs";
import { TrelloList } from "./commands";
import { SubTaskStatus } from "@/modules/setup/setupwizard";

interface Dictionary<T> {
    [Key: string]: T;
}
export class CreateSubscriptionFromTrello extends CqsDto {

    public static CqsDtoType = "CreateSubscriptionFromTrello";

    constructor(
        public Name: string,
        public Email: string,
        public StorymapName: string,
        public Password: string,
        public IsSubscribedToNewsletter: boolean,
        public NeedsHelpWith: string,
        public TrelloApiToken: string,
        public EpicNames: string[],
        public ListsToImport: TrelloList[],
        public CurrentReleaseName: string,
        public CurrentReleaseDescription: string,
        public CurrentReleaseDeadline: string,
        public NextReleaseName: string,
        public StatusMap: Dictionary<SubTaskStatus>,
        public ExportingList: TrelloList,
        public PersonalAccessToken: string,
        public ExternalProjectId: string,
    ){super();}
}

export class CreateSubscriptionFromTrelloResult {
    public IsSuccess: boolean;
    public Message: string;
    public PersonalAccessToken: string;
    public IntegrationIdentifier: string;
    public StorymapUrl: string;
}
